import { NgModule } from '@angular/core';

import { SharedModule } from '../shared.module';
import { SearchRoutingModule } from './search-routing.module';
import { SearchResultComponent } from 'src/app/components/search/search.result.component';
import { AdvertService } from 'src/app/services/advert.service';
import { SearchFormComponent } from 'src/app/components/search/searchForm/searchForm.component';
import { ConstantsService } from 'src/app/services/constants.service';
import { JobService } from 'src/app/services/job.service';
import { FilterSearchComponent } from 'src/app/components/search/filterSearch/filter-search.component';
import { FilterSearchService } from 'src/app/services/filter-search.service';
import { JobAlertService } from 'src/app/components/account/manage/job-alerts/services/job-alert.service';

@NgModule({
    imports: [
        SharedModule,
        SearchRoutingModule
    ],
    declarations: [
        SearchResultComponent,
        SearchFormComponent,
        FilterSearchComponent
    ],
    providers: [
        AdvertService,
        ConstantsService,
        JobService,
        AdvertService,
        FilterSearchService,
        JobAlertService
    ]
})
export class SearchModule { }
